export default __webpack_public_path__ + "static/media/thumbnail.a1234186.png";